import { render, staticRenderFns } from "./MetasEntrega.vue?vue&type=template&id=67cbdb38"
import script from "./MetasEntrega.vue?vue&type=script&lang=js"
export * from "./MetasEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports